BaseModel = require('base/model')

class LockedSettingModel extends BaseModel
  url: =>
    "accounts/#{@accountId}/lockedSettings"

  initialize: (options) =>
    { @accountId } = options

module.exports = LockedSettingModel